import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Anchor from '../../../../commonComponents/Anchor';

export default function ActionsColumn({ t, url }) {
  const linkClass = cx(
    'm-portlet__nav-link',
    'btn',
    'm-btn',
    'm-btn--hover-accent',
    'm-btn--icon',
    'm-btn--icon-only',
    'm-btn--pill',
  );

  const containerStyle = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={containerStyle}>
      <Anchor className={linkClass} href={url} title={t('details')}>
        <i className="la la-edit" />
      </Anchor>
    </div>
  );
}

ActionsColumn.propTypes = {
  t: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
};
